import { LendApiFullAppTab } from '../constants';
import { LendAPIProgressConfig, ValuePropConfig } from '../prequal/prequalProgressConfig';

const FULLAPP_VALUE_PROP_FIRST_PAGE: ValuePropConfig = {
  items: [
    { text: "We'll compare over 15 lenders to get you the best rate with the best terms" },
    { text: 'Once approved, you can finalize your loan within 24 hours' },
    { text: 'Zero down loans offered for boats up to $100,000' },
  ],
  primaryIcon: 'dollarSign',
  title: 'Your one-stop shop for boat loans',
};

const FULLAPP_VALUE_PROP_DEFAULT: ValuePropConfig = {
  items: [
    { text: "We'll encrypt your information to keep it secure." },
    { text: 'privacy-policy' },
    { text: 'No impact to your credit score!' },
  ],
  primaryIcon: 'shield',
  title: 'Your security is our top priority',
};

export const FULLAPP_PROGRESS_CONFIG: LendAPIProgressConfig<LendApiFullAppTab | string> = {
  milestones: [
    {
      name: 'About',
      tabs: new Set([
        LendApiFullAppTab.PROFILE_1,
        LendApiFullAppTab.PROFILE,
        LendApiFullAppTab.HOME_ADDRESS,
        LendApiFullAppTab.PREVIOUS_ADDRESS,
      ]),
    },
    {
      name: 'Financing Details',
      tabs: new Set([
        LendApiFullAppTab.BOAT_INFO_SELLER_INFO,
        LendApiFullAppTab.BOAT_INFO_TRADE_IN,
        LendApiFullAppTab.LOAN_INFO,
        LendApiFullAppTab.INCOME,
        LendApiFullAppTab.INCOME_EMPLOYMENT,
        LendApiFullAppTab.INCOME_LIQUID_RETIREMENT,
        LendApiFullAppTab.INCOME_REAL_ESTATE,
        LendApiFullAppTab.INCOME_OTHER_ASSETS,
        LendApiFullAppTab.INCOME_LIABILITIES,
        LendApiFullAppTab.INCOME_FINANCIAL_STATEMENT,
        LendApiFullAppTab.CONTACT_COBORROWER_INFO,
        LendApiFullAppTab.CONTACT_COBORROWER_ADDRESS,
        LendApiFullAppTab.CONTACT_COBORROWER_CONTACT,
        LendApiFullAppTab.CONTACT_COBORROWER_FINANCIAL,
      ]),
    },
    {
      name: 'Boat Info',
      tabs: new Set([LendApiFullAppTab.JD_POWER]),
    },
    {
      name: 'Confirm',
      tabs: new Set([
        LendApiFullAppTab.CREDIT_CONSENT,
        LendApiFullAppTab.CONFIRM,
        LendApiFullAppTab.SUBMITTED,
      ]),
    },
  ],
  tabLookup: new Map([
    [
      LendApiFullAppTab.LETS_GET_STARTED,
      { milestoneIndex: 0, isStartOfGroup: true, valueProp: FULLAPP_VALUE_PROP_FIRST_PAGE },
    ],
    [LendApiFullAppTab.PROFILE_1, { milestoneIndex: 0, isStartOfGroup: true }],
    [LendApiFullAppTab.PROFILE, { milestoneIndex: 0, isStartOfGroup: false }],
    [LendApiFullAppTab.HOME_ADDRESS, { milestoneIndex: 0, isStartOfGroup: false }],
    [LendApiFullAppTab.PREVIOUS_ADDRESS, { milestoneIndex: 0, isStartOfGroup: false }],
    [LendApiFullAppTab.BOAT_INFO_TRADE_IN, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.BOAT_INFO_SELLER_INFO, { milestoneIndex: 1, isStartOfGroup: true }],
    [LendApiFullAppTab.LOAN_INFO, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_EMPLOYMENT, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_LIQUID_RETIREMENT, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_REAL_ESTATE, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_OTHER_ASSETS, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_LIABILITIES, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.INCOME_FINANCIAL_STATEMENT, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.CONTACT_COBORROWER_INFO, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.CONTACT_COBORROWER_ADDRESS, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.CONTACT_COBORROWER_CONTACT, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.CONTACT_COBORROWER_FINANCIAL, { milestoneIndex: 1, isStartOfGroup: false }],
    [LendApiFullAppTab.JD_POWER, { milestoneIndex: 2, isStartOfGroup: true }],
    [LendApiFullAppTab.CREDIT_CONSENT, { milestoneIndex: 3, isStartOfGroup: true }],
    [LendApiFullAppTab.CONFIRM, { milestoneIndex: 3, isStartOfGroup: false }],
    [LendApiFullAppTab.SUBMITTED, { milestoneIndex: 3, isStartOfGroup: false }],
  ]),
  tabsWithNoValueProp: new Set([
    LendApiFullAppTab.CONFIRM,
    LendApiFullAppTab.CREDIT_CONSENT,
    LendApiFullAppTab.SUBMITTED,
  ]),
  defaultValueProp: FULLAPP_VALUE_PROP_DEFAULT,
};
